import type { MenuUrlV2WithDocId } from "@dashboard/types/menu-url-v2";
import type { ReduxState } from "@dashboard/types/reduxState";

import { RestaurantChangedAction } from "./restaurantReducer";

export type MenuUrlV2ReducerAction =
  | RestaurantChangedAction
  | { type: "FETCHED_MENU_URLS_V2"; payload: MenuUrlV2WithDocId[] }
  | { type: "FETCH_MENU_URLS_V2_FAILED" };

export const menuUrlV2Reducer: (
  state: ReduxState["menuUrlV2"] | undefined,
  action: MenuUrlV2ReducerAction
) => ReduxState["menuUrlV2"] = (
  state: ReduxState["menuUrlV2"] = {
    initialMenuUrlsV2Loading: true,
    fetchError: false,
    menuUrlsV2: [],
  },
  action: MenuUrlV2ReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_CHANGED":
      return {
        ...state,
        initialMenuUrlsV2Loading: true,
        fetchError: false,
      };
    case "FETCHED_MENU_URLS_V2":
      return {
        ...state,
        initialMenuUrlsV2Loading: false,
        fetchError: false,
        menuUrlsV2: action.payload,
      };
    case "FETCH_MENU_URLS_V2_FAILED":
      return {
        ...state,
        initialMenuUrlsV2Loading: false,
        fetchError: true,
      };
    default:
      return state;
  }
};
